export const AUTH_USER = 'AUTH_USER'
export const AUTH_TOKEN = 'AUTH_TOKEN'

// GLOBAL ERRORS
export const ERROR_UNAUTHORIZED = 'ERROR_UNAUTHORIZED'

export const AVATAR_IMAGE_SET = 'AVATAR_IMAGE_SET'

export const CLIENTS_LIST_LAST_UPDATED_EVENT = 'CLIENTS_LIST_LAST_UPDATED_EVENT'
export const USERS_LIST_LAST_UPDATED_EVENT = 'USERS_LIST_LAST_UPDATED_EVENT'
